import React, { useState } from 'react';
import Icons from "../../Icons";
import Modal from "react-responsive-modal";

interface ModalRemoveBackgroundProps {
  backgroundCanBeRemovedConditions: boolean;
  changeOptionEvent: (type: string, value: string, apply: boolean) => void;
  identifier: string;
}

export const ModalRemoveBackground = (props: ModalRemoveBackgroundProps) => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);

  function onCloseAlert() {
    setDisplayModal(false);
  }

  return (
    <>
      {props.backgroundCanBeRemovedConditions && 
        <div className={`position-absolute cursor-pointer`} style={{ top: '1px', right: '1px' }} title='Un fond uni a été détecté dans votre image, cliquez pour le supprimer'>
          <a onClick={() => setDisplayModal(true)} data-tip='' data-for={props.identifier+'remove-bg'} className={`batAutoBtnEditor mb-2 shadow border-0 batAutoBtnBgJustHover cursor-pointer`}>
            <Icons icon={'warning'} size={20}/>
          </a>
          {displayModal && <Modal classNames={{overlay: 'bootstrap-container'}} onClose={() => onCloseAlert()} open={displayModal} showCloseIcon={false} center={true}>
            <p className={"text-center"}>Un fond uni a été détecté dans votre image, souhaitez-vous le supprimer ?</p>
            <div className={"d-flex justify-content-between"}>
              <button className={"flex-column flex-lg-row justify-content-center align-items-center btnBatAuto btnBatAutoPrimary  black cursor-pointer"} onClick={() => onCloseAlert()}>Non</button>
              <button className={"btnBatAuto cursor-pointer bold text-center py-2 px-4 btnBatAutoBat"} onClick={() => props.changeOptionEvent('batAutoRemoveBackground', true, true)}>Oui</button>
            </div>
          </Modal>}
        </div>
      }
    </>
  );
}